import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ExtraFee} from '../../models/quote/extra-fee';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {EmployeeRoleEnum} from '../../models/employee/employee-role.enum';
import {ExtraFeeService} from "./extra-fee.service";

@Injectable()
export class RemoteExtraFeeService extends ExtraFeeService {
    API_URL = '/apiParams/v1/extrafees';

    constructor(
        private http: HttpClient) {
        super();
    }

    getExtraFeesByServiceAndCountryAndRole(country: string, role: EmployeeRoleEnum, serviceCode?: string): Observable<ExtraFee[]> {
        return this.http.get<any[]>(`${this.API_URL}/${country}/${role.pricingRole}`).pipe(
            map(rawExtraFees => rawExtraFees.map(rawExtraFee => new ExtraFee().copyWith({
                ...rawExtraFee,
                uniteAmount: rawExtraFee.amount,
                type: rawExtraFee.type?.code
            })))
        );
    }

}
